var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"i-flocktory",attrs:{"data-fl-action":"exchange","data-fl-spot":"some_spot","data-fl-user-name":_vm.name,"data-fl-user-email":_vm.email}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }